import { mutatorAction } from "satcheljs";
import UserTeamSettingsStore from "../store";
import { ObservableMap } from "mobx";

/**
 * Sets mute schedule group status for a schedule group (optimistic update).
 * Updates cache immediately for instant UI feedback. Revert on API failure.
 */
const setMuteScheduleGroupStatus = mutatorAction(
    "SET_MUTE_SCHEDULE_GROUP_STATUS",
    (teamId: string, scheduleGroupId: string, isMuted: boolean) => {
        const store = UserTeamSettingsStore();

        // Ensure team has muteScheduleGroupStatus map
        if (!store.muteScheduleGroupStatusByTeamAndGroup.has(teamId)) {
            store.muteScheduleGroupStatusByTeamAndGroup.set(teamId, new ObservableMap<string, boolean>());
        }

        // Update cache (triggers MobX reactivity)
        store.muteScheduleGroupStatusByTeamAndGroup.get(teamId).set(scheduleGroupId, isMuted);
    }
);

export default setMuteScheduleGroupStatus;
